import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { CBVendorSelectorResultDto } from '../../common/cb-vendor-selector-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';
import { APAdjustmentItemResultDto } from './ap-adjustment-item-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
const ɵ0 = () => Date, ɵ1 = () => Date, ɵ2 = () => Date, ɵ3 = () => Date, ɵ4 = () => CBVendorSelectorResultDto, ɵ5 = () => APAdjustmentItemResultDto, ɵ6 = () => UpdatedResultDto, ɵ7 = () => FileInfoDisplayResultDto, ɵ8 = () => KeyValueResultDto, ɵ9 = () => DimensionSelectorResultDto;
export class APAdjustmentResultDto {
    get referenceTypeText() {
        let refText = '';
        switch (this.referenceType) {
            case 'P':
                refText = 'Payment';
                break;
            case 'A':
                refText = 'Adjustment';
                break;
            case 'B':
                refText = 'Bill';
                break;
        }
        return `(Original AP ${refText})`;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], APAdjustmentResultDto.prototype, "docDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], APAdjustmentResultDto.prototype, "postDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], APAdjustmentResultDto.prototype, "deletedDate", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Date)
], APAdjustmentResultDto.prototype, "reversedDate", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", CBVendorSelectorResultDto)
], APAdjustmentResultDto.prototype, "vendor", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], APAdjustmentResultDto.prototype, "items", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", UpdatedResultDto)
], APAdjustmentResultDto.prototype, "lastUpdated", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", Array)
], APAdjustmentResultDto.prototype, "attachments", void 0);
tslib_1.__decorate([
    Type(ɵ8),
    tslib_1.__metadata("design:type", Array)
], APAdjustmentResultDto.prototype, "requiredDimensions", void 0);
tslib_1.__decorate([
    Type(ɵ9),
    tslib_1.__metadata("design:type", Array)
], APAdjustmentResultDto.prototype, "glDimensions", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9 };
